var voted_users_rtlignore_default = {
  "container": "Cb8e0",
  "webview": "QehrG",
  "avatar_list": "YfhIq",
  "avatar": "_0Xqdk",
  "user_avatar": "BHGkY",
  "modal": "QQwkX",
  "voted_users_modal": "_7aGPy",
  "overlay": "QqJkK",
  "user_card": "XpT-n",
  "user_name": "oSj2M",
  "voted_users_modal_header": "nCuKT",
  "cta": "cOM3f",
  "close_icon": "e-khv",
  "title": "pDnQ9",
  "member_list_container": "Wdi7k",
  "member_list": "dbeuM",
  "loader": "HxVa9",
  "anonymous_counter": "RYK-4",
  "spinner": "Qjw3w",
  "spin": "_50IG4"
};
export {
  voted_users_rtlignore_default as default
};
//# sourceMappingURL=voted-users.rtlignore-scss.js.map
